import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { WhyChooseSection } from "./components/WhyChooseSection";
import { MaterialsSection } from "./components/MaterialsSection";
import { IndustriesSection } from "./components/IndustriesSection";
import { HowItWorks } from "./components/HowItWorks";
import { ComplianceSection } from "./components/ComplianceSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { StatsSection } from "./components/StatsSection";
import { WhatsAppSection } from "./components/WhatsAppSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <WhyChooseSection />
        <MaterialsSection />
        <IndustriesSection />
        <HowItWorks />
        <ComplianceSection />
        <TestimonialsSection />
        <StatsSection />
        <WhatsAppSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
